import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
  FAQ: {},
  FAQs: [],
  totalPages: 0
}

// getters
const getters = {
  FAQ: (state) => {
    return state.FAQ;
  },
  FAQs: (state) => {
    return state.FAQs;
  },
  totalPages: (state) => {
    return state.totalPages;
  }
}

// mutations
const mutations = {
  SET_FAQ(state, FAQ) {
    state.FAQ = FAQ;
  },

  SET_FAQs(state, FAQs) {
    state.FAQs = FAQs;
  },

  SET_ACTION(state, action) {
    state.action = action;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_FAQ(state, FAQ) {
    state.FAQs.push(JSON.parse(JSON.stringify(FAQ)));
  },

  UPDATE_FAQs(state, FAQ) {
    let postIndex = state.FAQs.findIndex((item) => {
      return item.id === FAQ.id;
    });
    Vue.set(state.FAQs, postIndex, JSON.parse(JSON.stringify(FAQ)));
  },

  DELETE_FAQs(state, FAQ) {
    let postIndex = state.FAQs.findIndex((item) => {
      return item.id === FAQ.id;
    });

    if (postIndex > -1) {
      state.FAQs.splice(postIndex, 1);
    }
  }
}

// actions
const actions = {

    async getAllFAQs({commit}, [page, category, search]) {
      if (!search){
       await  axios.get('/admin/faqs?page=' + page + '&category=' + category)
            .then((response) => {
            let res = response.data;
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES',totalPages);
            commit('SET_FAQs', res.data);
      });
    }
    else{
         await axios.get('/admin/faqs?page=' + page + '&search=' + search + '&category=' + category)
            .then((response) => {
            let res = response.data;
            commit('SET_FAQs',res.data);
            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
      });
    }

  },

  // =========================================================================

  getUnpublishedFAQs({commit}, page) {
    axios.get('/admin/faqs/unpublished?page=' + page)
    .then((response) => {
      let res = response.data;
      commit('SET_FAQs', res.data);

      let totalPages = Math.ceil(res.total / res.per_page);
      commit('SET_TOTAL_PAGES', totalPages);
    });
  },

  // =========================================================================

  async getFAQ({commit}, FAQ) {
    const response = await axios.get('/admin/faqs/' + FAQ);
    commit('SET_FAQ', response.data.faq);
  },

  // =========================================================================

  getCategoryFAQs({commit}, payload) {
    axios.get('/admin/faqcategories/' + payload.FAQcategory + '/faqs?page=' + payload.page)
    .then((response) => {
       let res = response.data;
       commit('SET_FAQs', res.data);

       let totalPages = Math.ceil(res.total / res.per_page);
       commit('SET_TOTAL_PAGES', totalPages);
     });
  },


  // =========================================================================

  createFAQ({}, FAQ) {
    let formData = new FormData();
    formData.append('title', FAQ.title);
    formData.append('body', FAQ.body);
    formData.append('video', FAQ.video);
    formData.append('order_number', FAQ.order_number);
    formData.append('category_id', FAQ.FAQcategory.id);

    return axios.post('/admin/faqs', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      return response.data.FAQ.slug;
    })
  },

  // =========================================================================

  updateFAQ ({}, FAQ) {

    let formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('title', FAQ.title);
    formData.append('body', FAQ.body);
    formData.append('video', FAQ.video);
    formData.append('order_number', FAQ.order_number);
    formData.append('category_id', FAQ.FAQcategory.id);
    formData.append('slug', FAQ.slug);
    return axios.post('/admin/faqs/' + FAQ.slug, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      return response.data.FAQ.slug;

    });
  },

  // =========================================================================

  deleteFAQ({commit}, FAQ) {
    return axios.post('/admin/faqs/' + FAQ.slug, {
      '_method': 'DELETE'
    })
    .then((response) => {
      commit('DELETE_FAQs', FAQ);
      return response.data.message;
    });    
  },

  // =========================================================================

  publishing({commit}, payload) {
    return axios.post('/admin/faqs/' + payload.FAQ.slug + '/publishing?action=' + payload.action)
      .then((response) => {
        switch (payload.action) {
          case 'publish':
            payload.FAQ.published = 1;
            payload.FAQ.published_at = 'Just now';
            break;
          case 'unpublish':
            payload.FAQ.published = 0;
            payload.FAQ.published_at = '';
            break;
        }

        commit('SET_FAQ', payload.FAQ);
        return response;
      });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
